import { Component, ChangeDetectionStrategy, Input, inject } from '@angular/core';
import { DmsBaseFolderAction } from '@iris/common/modules/dms/components/actions/folder-actions/dms-base-folder-action';
import { IrisDmsModalsSandbox } from '@iris/common/modules/dms/sandbox/dms-modals.sandbox';
import { NgClass } from '@angular/common';
import { MatTooltipModule } from '@angular/material/tooltip';
import { StrakitButtonComponent } from '@ngx-strakit/cdk/controls';
import { StrakitButtonPrefixDirective } from '@ngx-strakit/cdk';
import { MatMenuItem } from '@angular/material/menu';

@Component({
  selector: 'iris-dms-add-folder-button',
  templateUrl: './dms-add-folder-button.component.html',
  styleUrls: ['./dms-add-folder-button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    NgClass,
    MatTooltipModule,
    StrakitButtonComponent,
    StrakitButtonPrefixDirective,
    MatMenuItem,
  ],
})
export class IrisDmsAddFolderButtonComponent extends DmsBaseFolderAction {
  private readonly dmsModalsSandbox = inject(IrisDmsModalsSandbox);

  @Input() setSelected = false;

  protected _label = 'label.AddNewFolder';

  showAddFolderModal(): void {
    this.dmsModalsSandbox.showAddFolderModal(this.folderId(), this.setSelected);
  }
}
